import {
  CLIENT_SIDE,
  NOONE_SIDE,
  SERVICE_SIDE,
  TEMPORARILY_SAVED_SIDE,
} from "../../../constants";
import { Divider as MuiDivider, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { Alert } from "@material-ui/lab";
import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../../components/GovGrMaterialTable";
import { Helmet } from "react-helmet-async";
import dayjs from "dayjs";
import { fetchApplicationsByAfm } from "../../../services/applicationsService";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import GovGrButton from "../../../components/GovGrButton";
import GovGrBreadcrumbs from "../../../components/GovGrBreadCrumbs";

const Divider = styled(MuiDivider)(spacing);

const ActionRequiredRender = ({ rowData }) => {
  const { t } = useLocale();

  switch (rowData.asts_isService) {
    case CLIENT_SIDE:
      return <Alert severity="error">{t("Yes")}</Alert>;
    case TEMPORARILY_SAVED_SIDE:
      return <Alert severity="error">{t("Yes")}</Alert>;
    case NOONE_SIDE:
      return <Alert severity="success">{t("No")}</Alert>;
    case SERVICE_SIDE:
      return <Alert severity="success">{t("No")}</Alert>;
    default:
      return <Alert severity="success">{t("No")}</Alert>;
  }
};

const MyApplications = () => {
  const { t } = useLocale();
  const afm = useSelector((state) => state?.authReducer?.user?.afm);

  const {
    data,
    isLoading,
    isError,
    refetch: refetchApplications,
  } = useQuery("myapplications", () => fetchApplicationsByAfm(afm));
  let history = useHistory();

  return (
    <>
      <Helmet title={t("My applications")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("My applications")}
      </Typography>

      <GovGrBreadcrumbs
        segments={[
          { href: "/", label: t("Dashboard") },
          { label: t("My applications") },
        ]}
      />

      <Divider my={6} />
      <CustomAlert
        open={isError}
        close={() => {
          refetchApplications();
        }}
        message={t("A network error occured, please try again later")}
      />
      <CustomTable
        isLoading={isLoading}
        columns={[
          {
            title: t("Action required from you"),
            field: "asts_isService",
            render: (rowData) => <ActionRequiredRender rowData={rowData} />,
          },
          {
            title: t("Appointment"),
            width: "30%",
            render: (appl) =>
              appl.a_rndv_from ? (
                <Alert>
                  {`${t("From")} ` +
                    dayjs(appl.a_rndv_from).format("DD/MM/YYYY")}
                </Alert>
              ) : (
                "-"
              ),
          },
          {
            title: t("AFM"),
            field: "a_afm_afora",
            width: "100px",
          },
          {
            title: t("Protocol Number"),
            field: "a_reg_num",
            width: "100px",
          },
          {
            title: t("Application Date"),
            field: "a_appl_dt",
            render: (rowData) => (
              <> {dayjs(rowData.a_appl_dt).format("DD/MM/YYYY")}</>
            ),
            defaultSort: "desc",
          },
          {
            title: t("Surname"),
            field: "a_lname_ait",
          },
          {
            title: t("Name"),
            field: "a_fname_ait",
          },

          {
            title: t("Application Kind"),
            field: "ak_applicationKind",
          },
          {
            title: t("Application Status"),
            field: "asts_statusDscr",
          },
        ]}
        data={data}
        onEdit={(event, rowData) => {
          history.push("/editApplications/application", {
            id: rowData.a_id,
          });
        }}
        editLabel={t("View")}
        options={{
          showTitle: false,
        }}
      />
    </>
  );
};

export default MyApplications;
